import { Box, IconButton, Snackbar, Stack, Button } from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'
import { useModal } from '@/hooks'
import { ModalType } from '@/store/app'
import type { CertificateNotificationProps } from './types'
import { WarningIcon } from '../icons'
import { styles } from './styles'
import { useNavigate } from 'react-router-dom'
import { getNotificationText } from './utils'

export const CertificateNotification = (
  props: CertificateNotificationProps
) => {
  const { data, pastNotification } = props
  const { modalOpened, hideModal } = useModal()
  const navigate = useNavigate()

  const handleClose = (
    event: React.SyntheticEvent | Event,
    reason?: string
  ) => {
    if (reason === 'clickaway') {
      return
    }
    pastNotification()
    hideModal()
  }
  const handleNavigate = () => {
    hideModal()
    if (data?.id) {
      pastNotification()
      navigate(`/medcomplex/${data?.id}/certificate`)
    }
  }

  return (
    <Snackbar
      sx={styles.snackBar}
      open={modalOpened === ModalType.MEDCOMPLEX_CERTIFICATE_NOTIFICATION}
      autoHideDuration={3000}
      onClose={handleClose}
      message={
        <Stack sx={styles.container}>
          <Stack sx={styles.notification}>
            <Box>{data?.icon ? data?.icon : <WarningIcon />}</Box>
            <Stack>
              <Box sx={styles.title}>Уведомление</Box>
              <Box>{getNotificationText(data)}</Box>
            </Stack>
          </Stack>
          {data?.id && (
            <Button
              variant="contained"
              sx={styles.navigateButton}
              onClick={handleNavigate}
            >
              Открыть
            </Button>
          )}
        </Stack>
      }
      anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      action={
        <Box>
          <IconButton
            size="small"
            //aria-label="close"
            color="inherit"
            onClick={handleClose}
          >
            <CloseIcon fontSize="small" />
          </IconButton>
        </Box>
      }
    />
  )
}
